// 开启 HMR 支持
import 'react-hot-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import App from '@/App.tsx';
import { isDeviceOpen, fetchProd } from '@tools/func.ts';

if (isDeviceOpen()) {
  window.location.href = 'https://hd.huya.com/h5/10_allstar_detail/index.html?anchorUid=895332955';
  // ReactDOM.render(<App />, document.getElementById('root'));
} else {
  ReactDOM.render(<App />, document.getElementById('root'));
}
